export enum WorkflowObject {
  DOCUMENT = "DOCUMENT",
  WORKFLOW = "WORKFLOW"
}

export enum WorkflowStepActionType {
  APPROVE = "APPROVE",
  FINISH = "FINISH"
}

export enum WorkflowStepAssigneeType {
  USER = "USER",
  ROLE = "ROLE"
}

export interface WorkflowDefinition {
  id: string;
  name: string;
  description: string;
  objectType: WorkflowObject;
  objectSubType: string;
  version: number;
  isCurrent: boolean;
  companyId: number | null;
};

export interface WorkflowStep {
  id: string;
  name: string;
  assignees: WorkflowStepAssignee[];
  actions: WorkflowAction[];
}

export interface WorkflowStepAssignee {
  id: string;
  assigneeType: WorkflowStepAssigneeType;
  assigneeValue: string;
}

export interface WorkflowAction {
  id: string;
  label: string;
  actionType: WorkflowStepActionType;
  rejectGoToStepId: string | null;
}


export interface UpdateWorkflowStepsDto {
  steps: WorkflowStep[];
}

export interface CreateWorkflowDefinition {
  name: string;
  objectType: WorkflowObject;
  objectSubType: string;
}

export interface WorkflowRole {
  id: string;
  code: string;
  name: string;
  order: number;
  isSystemRole: boolean;
}

export interface CreateWorkflowRole {
  code: string;
  name: string;
}

export interface UpdateWorkflowRole {
  code: string;
  name: string;
}